import { injectIntl, IntlShape } from 'react-intl';
import { EventLevelAttributePresentation } from './event-level-attributes.presentation';
import { EventLevelAttributesVM } from './event-level-attributes.viewmodel';
import { connectedManageAttributesVM } from '../manage-attributes.context';
import { withViewModel } from '../../../../infrastructure/components/with-view-model';

export type ContainerProps = {
    accountId: number;
};

const EventLevelAttributesContainer = injectIntl(withViewModel(
    EventLevelAttributePresentation,
    ({ accountId, intl }: ContainerProps & { intl: IntlShape }) => {
        const eventLevelAttributesVM = new EventLevelAttributesVM(accountId, intl);

        eventLevelAttributesVM.initialize();

        return eventLevelAttributesVM;
    },
    props => [props.accountId]
));

export const EventLevelAttributes = connectedManageAttributesVM<ContainerProps>(
    EventLevelAttributesContainer,
    vm => ({
        accountId: vm.getAccountId()
    })
);
